// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__z6GZz","fileBtn":"File_fileBtn__1_l0o","closeBtn":"File_closeBtn__11z9L","fileSelected":"File_fileSelected__2Yszq","disabled":"File_disabled__32pdK"};